import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { faTrophy, faRankingStar, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CTFStatsSection() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await fetch('https://usscfedora.org/ctfstats.php', {
                    method: 'GET',
                    credentials: 'include',
                });
                
                if (!response.ok) {
                    throw new Error('Failed to fetch stats');
                }

                const data = await response.json();
                setStats(data);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching CTF stats:', err);
                setError('Failed to load CTF statistics');
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    if (loading) {
        return (
            <section className="landing-page-stats">
                <Container fluid>
                    <div className="landing-page-stats-loading">
                        <p>Loading CTF statistics...</p>
                        <div className="landing-page-stats-spinner"></div>
                    </div>
                </Container>
            </section>
        );
    }

    if (error) {
        return (
            <section className="landing-page-stats">
                <Container fluid>
                    <div className="landing-page-stats-error">
                        <p>{error}</p>
                        <button 
                            onClick={() => window.location.reload()} 
                            className="landing-page-stats-retry"
                        >
                            Retry
                        </button>
                    </div>
                </Container>
            </section>
        );
    }

    return (
        <section className="landing-page-stats">
            <Container fluid>
            <Row className="justify-content-center">
                    <Col md={10} lg={8} className="text-center mb-5">
                        <h2 className="landing-page-stats-title high-tech-font">Our CTF Journey</h2>
                        <div className="landing-page-stats-underline"></div>
                        <p className="landing-page-stats-subtitle">Track our progress on CTFtime</p>
                    </Col>
                </Row>

                <Row className="justify-content-center g-4">
                    <Col md={4}>
                        <div className="landing-page-stats-card">
                            <div className="landing-page-stats-icon-wrapper">
                                <FontAwesomeIcon icon={faRankingStar} className="landing-page-stats-icon" />
                            </div>
                            <h3 className="landing-page-stats-card-title">Global Ranking</h3>
                            <p className="landing-page-stats-value">
                                {stats?.rating?.global_place !== 'N/A' ? `#${stats?.rating?.global_place}` : 'N/A'}
                            </p>
                        </div>
                    </Col>

                    <Col md={4}>
                        <div className="landing-page-stats-card">
                            <div className="landing-page-stats-icon-wrapper">
                                <FontAwesomeIcon icon={faTrophy} className="landing-page-stats-icon" />
                            </div>
                            <h3 className="landing-page-stats-card-title">Total Rating Points</h3>
                            <p className="landing-page-stats-value">
                                {stats?.rating?.total_points?.toFixed(2) || 'N/A'}
                            </p>
                        </div>
                    </Col>

                    <Col md={4}>
                        <div className="landing-page-stats-card">
                            <div className="landing-page-stats-icon-wrapper">
                                <FontAwesomeIcon icon={faChartLine} className="landing-page-stats-icon" />
                            </div>
                            <h3 className="landing-page-stats-card-title">Country Rank</h3>
                            <p className="landing-page-stats-value">
                                {stats?.rating?.country_place !== 'N/A' ? `#${stats?.rating?.country_place}` : 'N/A'}
                            </p>
                        </div>
                    </Col>
                </Row>

                <Row className="justify-content-center mt-4">
                    <Col md={6} className="text-center">
                        <a 
                            href="https://ctftime.org/team/358628/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="landing-page-stats-link"
                        >
                            View Full Profile on CTFtime
                        </a>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default CTFStatsSection;